import request from '@/router/axios'

const base = '/api/produce/railway-plan-completion'

export const fetchKpi = (data) =>
  request({ url: `${base}/kpi`, method: 'post', data })

export const fetchPlanVsActual = (data) =>
  request({ url: `${base}/planVsActual`, method: 'post', data })

export const fetchAchievementTrend = (data) =>
  request({ url: `${base}/achievementTrend`, method: 'post', data })

export const fetchDetailPage = (data) =>
  request({ url: `${base}/detailPage`, method: 'post', data })

export const fetchDeviationAnalysis = (data) =>
  request({ url: `${base}/deviationAnalysis`, method: 'post', data })

export const fetchDeptPerformance = (data) =>
  request({ url: `${base}/deptPerformance`, method: 'post', data })

export const searchVardictPycode = (cargoName) =>
  request({
    url: '/api/produce/vardict/select/distinct/pycode',
    method: 'get',
    params: {
      cargoName: cargoName != null ? String(cargoName) : '',
      varName: cargoName != null ? String(cargoName) : '',
      page: 1,
      size: 50
    }
  })

/** 货主下拉（blade_dept，dept_type=0） */
export const fetchBladeDeptCargoOwners = (data) =>
  request({
    url: '/api/produce/blade-dept/select/distinct/select',
    method: 'post',
    data: data || {}
  })
